import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { InputStatesStore } from "stores/inputs/InputStatesStore";
import { isInputRunning, isInputInSetupMode } from "components/inputs/helpers/inputState";
import useFeature from "hooks/useFeature";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { getPathnameWithoutId } from "util/URLUtils";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { Button } from "components/bootstrap";
import { INPUT_SETUP_MODE_FEATURE_FLAG } from "components/inputs/InputSetupWizard";
const StateActionButton = styled(Button)(
  () => css`
    min-width: 95px;
  `
);
const InputStateControl = ({ input, openWizard, inputStates }) => {
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const inputSetupFeatureFlagIsEnabled = useFeature(INPUT_SETUP_MODE_FEATURE_FLAG);
  const startInput = () => {
    setIsLoading(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_START_CLICKED, {
      app_pathname: getPathnameWithoutId(pathname),
      app_action_value: "start-input"
    });
    InputStatesStore.start(input).finally(() => {
      setIsLoading(false);
    });
  };
  const stopInput = () => {
    setIsLoading(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_STOP_CLICKED, {
      app_pathname: getPathnameWithoutId(pathname),
      app_action_value: "stop-input"
    });
    InputStatesStore.stop(input).finally(() => {
      setIsLoading(false);
    });
  };
  const setupInput = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_SETUP_CLICKED, {
      app_pathname: getPathnameWithoutId(pathname),
      app_action_value: "setup-input"
    });
    openWizard();
  };
  if (inputSetupFeatureFlagIsEnabled && isInputInSetupMode(inputStates, input.id)) {
    return /* @__PURE__ */ React.createElement(StateActionButton, { bsStyle: "warning", bsSize: "xsmall", onClick: setupInput }, "Set-up Input");
  }
  if (isInputRunning(inputStates, input.id)) {
    return /* @__PURE__ */ React.createElement(StateActionButton, { bsSize: "xsmall", onClick: stopInput, disabled: isLoading }, isLoading ? "Stopping..." : "Stop input");
  }
  return /* @__PURE__ */ React.createElement(StateActionButton, { bsStyle: "primary", bsSize: "xsmall", onClick: startInput, disabled: isLoading }, isLoading ? "Starting..." : "Start input");
};
export default InputStateControl;
